import React from "react";
import 'Assets/Reports/EventMarkers.css';

export interface ColorBlockProps {
    setColor: Function;
    currentSelection: string;
    disableValue: boolean;
}

export const EnsembleColorBlocks = (props: ColorBlockProps) => {
    const {
        setColor,
        currentSelection,
        disableValue
    } = props;

    const setColorValue = (hexColor: string) => {
        if (!disableValue && hexColor !== '' && hexColor !== currentSelection) {
            setColor(hexColor);
        }
    }

    const setClassName = (hexColor: string) => {
        return hexColor === currentSelection ? 'colorBlockSelected' : 'colorBlocks';
    }

    const setOuterClassName = (hexColor: string) => {
        return hexColor === currentSelection ? 'colorBlockOuterSelected' : 'colorBlockOuter';
    }

    const colors : Array<string> = [
        "FF0000", 
        "000000", 
        "FB9804", 
        "CFCF05", 
        "00B050", 
        "0066FF", 
        "3333CC", 
        "7030A0", 
        "FF00FF", 
        "800000", 
        "BFBFBF", 
        "FFB3B3", 
        "FDC97B", 
        "92D050", 
        "91FFC2", 
        "66CCFF", 
        "00B0F0", 
        "BC8EDD", 
        "FFCCFF", 
        "CC3300"
    ];

    function displayColorOptions() {
        return colors.map(function (c) {
            return (
                <li key={c} className="colorBlockListItem"><div className={setOuterClassName(c)}><div style={{backgroundColor: '#' + c}} className={setClassName(c)} onClick={() => {setColorValue(c)}}></div></div></li>
            )
        })
        
    }

    const colorOptions = displayColorOptions();

    return (
        <ul className="colorBlockHolder">
            {colorOptions}
        </ul>

    )

}

export default EnsembleColorBlocks;